import type { RecordLikeProtocol } from '@lighthouse/core'
import { pageStackPubSub } from '@lighthouse/shared'
import { useEffect } from 'react'

import type { FetchViewDataPayload } from '../types'

type UseSubscribeViewPayload = {
    pointer: string | undefined
    pageNum?: number
    fetchViewData: (params: FetchViewDataPayload) => void
}

export const useSubscribeView = (payload: UseSubscribeViewPayload) => {
    const { pointer, pageNum = 1, fetchViewData } = payload
    // 订阅创建
    useEffect(() => {
        if (!pointer) {
            return
        }
        const { subscribeId, unSubscribe } = pageStackPubSub.subscribe(`${pointer}-ADD`, (record?: RecordLikeProtocol) => {
            fetchViewData({ pageNum })
        })
        return () => unSubscribe(subscribeId)
    }, [fetchViewData, pageNum, pointer])
}
